import NotesCard from './NotesCard';
import { isNoteEditable } from './notesAccess';

/**
 * The one Notes wrapper both report views render (ACT-18544 item 4).
 *
 * It renders nothing outside the portfolio (the views keep their own
 * isPortfolio blocks; this guard makes the wrapper self-contained), and the
 * editor follows the server rule from tpaccurate-api#189: a stored-row role
 * guard answers 403 for role users on portfolio rows, and the shared axios
 * interceptor turns ANY 403 into a forced logout - so the editor must not be
 * offered to them in the first place. The decision lives in isNoteEditable
 * (./notesAccess), fail-closed on unknown roles.
 */
function PortfolioNotesCard({ isPortfolio, isInTrash, note, onChange, onSave, role, status }) {
  if (!isPortfolio) return null;

  return (
    <NotesCard
      description="Include any notes on the report here."
      editMode={isNoteEditable(role, isPortfolio, status, isInTrash)}
      note={note}
      onChange={onChange}
      onSave={onSave}
    />
  );
}

export default PortfolioNotesCard;
